module.exports = __webpack_public_path__ + "1bc436ae4c046640c1b7840c2a2eac38.png";